import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { API } from "@/lib/api";

export default function LinkRedirect() {
  const { code, slug } = useParams();
  const [error, setError] = useState(null);
  const [destination, setDestination] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API}/links/resolve/${encodeURIComponent(code)}/${encodeURIComponent(slug)}`);
        if (!res.ok) {
          if (alive) setError(res.status);
          return;
        }
        const data = await res.json();
        if (!alive) return;
        setDestination(data.destination_url);
        // brief interstitial then redirect (feels transparent)
        setTimeout(() => {
          window.location.replace(data.destination_url);
        }, 250);
      } catch (e) {
        if (alive) setError("network");
      }
    })();
    return () => {
      alive = false;
    };
  }, [code, slug]);

  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="link-redirect">
      <div className="eigoo-card p-8 max-w-md text-center">
        {error ? (
          <>
            <div className="w-12 h-12 mx-auto rounded-full grid place-items-center border border-[#f87171]/40 bg-[#f87171]/10 text-[#f87171]">
              <AlertTriangle className="w-5 h-5" />
            </div>
            <h1 className="font-display text-xl font-bold mt-4">Link not found</h1>
            <p className="text-sm text-slate-400 mt-2">
              We couldn't find a partner link at
              <span className="font-mono text-slate-300"> /l/{code}/{slug}</span>.
            </p>
            <a
              href="/"
              className="ghost-btn inline-flex items-center gap-2 mt-6 text-sm"
              data-testid="redirect-home-link"
            >
              Return home <ArrowRight className="w-4 h-4" />
            </a>
          </>
        ) : (
          <>
            <div className="w-10 h-10 mx-auto rounded-full border-2 border-[#d4a843]/40 border-t-[#f3c669] animate-spin" />
            <h1 className="font-display text-lg font-bold mt-5">Routing your click…</h1>
            <p className="text-xs text-slate-400 mt-1 font-mono truncate max-w-full">
              → {destination || `${code} / ${slug}`}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
